module.exports = __webpack_public_path__ + "static/media/createUserNavigation.7979c229.png";